var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleSignIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.66 12.1932C20.66 11.5905 20.6059 11.011 20.5055 10.4546H12.5V13.7425H17.0746C16.8775 14.8051 16.2786 15.7053 15.3784 16.308V18.4407H18.1255C19.7327 16.961 20.66 14.7819 20.66 12.1932Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5002 20.5002C14.7952 20.5002 16.7193 19.7391 18.1257 18.4409L15.3786 16.3082C14.6175 16.8182 13.6439 17.1196 12.5002 17.1196C10.2864 17.1196 8.41248 15.6243 7.74407 13.6152H4.9043V15.8175C6.30294 18.5955 9.17749 20.5002 12.5002 20.5002Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74387 13.6149C7.57387 13.1049 7.47728 12.5601 7.47728 11.9999C7.47728 11.4397 7.57387 10.8949 7.74387 10.3849V8.18262H4.90409C4.32841 9.33012 4 10.6283 4 11.9999C4 13.3715 4.32841 14.6697 4.90409 15.8172L7.74387 13.6149Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5002 6.88069C13.7482 6.88069 14.8686 7.30955 15.7495 8.15183L18.1875 5.71387C16.7155 4.34227 14.7914 3.5 12.5002 3.5C9.17748 3.5 6.30294 5.40478 4.9043 8.18273L7.74407 10.385C8.41248 8.37592 10.2864 6.88069 12.5002 6.88069Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSignIn);
export default __webpack_public_path__ + "static/media/google_sign_in.9f63aeab4d09eb000d7bfbc5f16fcb39.svg";
export { ForwardRef as ReactComponent };